/* eslint-disable */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import s from './originals.module.css';
import { Ico } from '../ShellIcons';
import { itemLine } from '../cards/OriginalsCardV3';

// ============================================================
// OriginalsCompare — the selected originals side by side (2–6): the photo and
// the facts, a fact in amber when it differs across the columns. Escape and
// the backdrop close it. Portaled to body with its own tokens (#142).
// ============================================================

const ROWS = [
  ['Shape', (i) => i.shape1 || i.shape || ''], ['Gender', (i) => i.gender || ''], ['Material', (i) => i.material || ''],
  ['Line', (i) => itemLine(i)], ['Model', (i) => i.model || ''], ['Status', (i) => i.status || ''], ['Assigned', (i) => i.assignedTo || ''],
];
const PH = (<svg viewBox="0 0 140 64" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"><ellipse cx="44" cy="32" rx="30" ry="21" /><ellipse cx="96" cy="32" rx="30" ry="21" /><path d="M74 32h-8M14 27 2 22M126 27l12-5" /></svg>);

export default function OriginalsCompare({ items, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onClose]);
  const list = (items || []).slice(0, 6);
  const diff = (get) => new Set(list.map((i) => String(get(i) || '').trim().toLowerCase())).size > 1;
  return ReactDOM.createPortal(
    <div className={s.cmpWrap} onClick={onClose} data-shell-pop>
      <div className={s.cmp} role="dialog" aria-label="Compare originals" style={{ width: `min(calc(100vw - 32px), ${Math.max(620, list.length * 300 + 32)}px)` }} onClick={(e) => e.stopPropagation()}>
        <div className={s.cmpHead}><h2>Compare</h2><span className={s.n}>{list.length} originals · a fact in amber differs</span><button type="button" className={s.cmpX} aria-label="Close" onClick={onClose}><Ico name="x" /></button></div>
        <div className={s.cmpBody}>
          {list.map((it) => {
            const img = (it.images || [])[0] || it.image || null;
            return (
              <div key={it.id} className={s.col}>
                <div className={s.colTop}>{it.brand || '—'}{it.sku ? <small>{it.sku}</small> : null}</div>
                <div className={s.colImg}>{img ? <img src={img} alt="" loading="lazy" /> : <span className={s.ph}>{PH}</span>}</div>
                {ROWS.map(([label, get]) => <div key={label} className={`${s.row} ${diff(get) ? s.diff : ''}`}><small>{label}</small><span>{get(it) || '—'}</span></div>)}
              </div>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
}
